module.exports = __webpack_public_path__ + "img/19m.bb742efe.jpg";